import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import logo_white from 'styles/assets/logo_white.webp';
import { trackEventMatomo } from 'js/library/utils/helpers';
import androidImage from 'styles/assets/Download/download_android.webp';
import appleImage from 'styles/assets/Download/download_ios.webp';

export const FooterPromotion = () => {
  const { t } = useTranslation('app');

  return (
    <div style={{ backgroundColor: '#324996', padding: '20px 0px', textAlign: '-webkit-center' }}>
      <div className="top-bar">
        <div>
          <img src={logo_white} style={{ maxWidth: '20%', padding: 10 }} alt="by triibo" />
        </div>
        <div>
          <Typography
            variant="caption"
            color="primary"
            style={{ fontWeight: 'bolder', padding: 10 }}
          >
            {t('general.download_the_app_and_enjoy_more_experiences')}
          </Typography>
        </div>

        <a
          href="https://triibo.page.link/TWAF"
          onClick={() => {
            trackEventMatomo('Resgate por link externo', 'tocar', 'footer', 'baixar App IOS');
          }}
          target="new"
        >
          <img src={appleImage} alt="download ios" style={{ maxWidth: '40%', padding: 10 }} />
        </a>

        <a
          href="https://triibo.page.link/1c84"
          onClick={() => {
            trackEventMatomo('Resgate por link externo', 'tocar', 'footer', 'baixar App Android');
          }}
          target="new"
        >
          <img src={androidImage} alt="downloadAndroid" style={{ maxWidth: '40%', padding: 10 }} />
        </a>
      </div>
    </div>
  );
};

export default FooterPromotion;
